module.exports = __webpack_public_path__ + "static/media/forwardhead_severe_right.549e7f8e.png";